import baseProvider from "../providers/BaseProvider";
import EffectivePermissionsProvider from "../providers/EffectivePermissionsProvider";

export default {
    state: {
        title: "App Name",
        serverStatus: false,
        serverTime: null,
        serverError: null
    },
    getters: {
        getTitle: (state) => {
            return state.title
        },
        getServerStatus: (state) => {
            return state.serverStatus
        }
    },
    actions: {
        /**
         * Fetches effective permissions for the current user from the backend
         * (which applies UserPermission overrides: additional + revoked).
         * Replaces state.user.me.role.permissions so hasPermission() reflects overrides.
         * Call after login (fetchMe) and on page load when already authenticated.
         */
        fetchEffectivePermissions({ commit, rootState }) {
            return EffectivePermissionsProvider.fetchEffectivePermissions()
                .then(r => {
                    const effectivePerms = r.data.myEffectivePermissions || [];
                    const currentMe = rootState.user.me;
                    if (currentMe && currentMe.role) {
                        // Replace permissions in the stored me object.
                        // setMe is a global mutation from UserModuleStore (non-namespaced).
                        commit('setMe', {
                            ...currentMe,
                            role: {
                                ...currentMe.role,
                                permissions: effectivePerms
                            }
                        });
                    }
                })
                .catch(err => {
                    console.error('[EffectivePermissions] Error fetching effective permissions:', err);
                    // Silent fail — backend still enforces permissions via RBAC
                });
        },
        ping({commit}) {
            let begin = Date.now()
            baseProvider.ping().then(r => {
                let time =  Date.now() - begin
                commit('setServerStatus', r.data.ping.status)
                commit('setServerTime', time)

            }).catch(e => {
                commit('setServerStatus', false)
                commit('setServerTime', 0)
                commit('setServerError', e.message)
            })
        }
    },
    mutations: {
        setServerStatus(state, status) {
            state.serverStatus = status
        },
        setServerTime(state, time) {
            state.serverTime = time
        },
        setServerError(state, error) {
            state.serverError = error
        }
    }
}